import * as actionTypes from './actionTypes';

export const setUserAdminDetail = data => ({
  type: actionTypes.SET_USER_ADMIN_DETAIL,
  data
})

export const setGroupAdminDetail = data => ({
  type: actionTypes.SET_GROUP_ADMIN_DETAIL,
  data
})

export const setCustomerAdminDetail = data => ({
  type: actionTypes.SET_CUSTOMER_ADMIN_DETAIL,
  data
})

export const setAdminTabIndex = index => ({
  type: actionTypes.SET_ADMIN_TAB_INDEX,
  index
})

export const createGroup = group => ({
  type: actionTypes.CREATE_GROUP,
  group
})

export const newManualCase = newCase => ({
  type: actionTypes.NEW_MANUAL_CASE,
  newCase
})

export const restoreManualCase = newCase => ({
  type: actionTypes.DESTROY_SESSION,
  newCase
})

export const activeTab = index => ({
  type: actionTypes.ACTIVE_TAB,
  index
})

export const redirectToTab = index => ({
  type: actionTypes.GO_TO_TAB,
  index
})

export const rafPackDetails = newRAFPack => ({
  type: actionTypes.SAVE_RAF_DETAILS,
  newRAFPack
})


export const deleteRafPackDetails = () => ({
  type: actionTypes.DELETE_RAF_DETAILS
})

export const rafPackNotFound = (status) => ({
  type: actionTypes.PACK_NUMBER_NOT_FOUND,
  status
})

export const disableTabs = index => ({
  type: actionTypes.DISABLE_ADMIN_CASEBODY_TABS,
  index
})



// WEBPACK FOOTER //
// ./src/components/Admin/actions/actionCreator.js